export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    title: that.$l('form_label_materialNo') || '物料编码',
    field: 'materialNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_materialName') || '物料名称',
    field: 'materialName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_cd') || 'CD#',
    field: 'cd',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_materialDesc') || '规格型号尺寸',
    field: 'materialDesc',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_materialRequirement') || '材质要求',
    field: 'materialRequirement',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_qty') || '数量',
    field: 'qty',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_qtyUnit') || '单位',
    field: 'qtyUnit',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_unitPrice') || '含税单价',
    field: 'unitPrice',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_subAmount') || '价税合计',
    field: 'subAmount',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("form_label_originOrderNo") || "源头单号",
    field: "originOrderNo",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("form_label_planArrivalDate") || "计划到货日期",
    field: "planArrivalDate",
    headerAlign: "center",
    align: "center",
    minWidth: 130,
    showHeaderOverflow: true,
  }
]
